import { FunctionExpression } from "./abstract.functionExpression";
import { UnaryExpression } from "./abstract.unary.expression";
import { ToLowerFunction } from "./toLowerFunction";

export class StartsWithFunction extends FunctionExpression
{
    constructor(field: string | UnaryExpression, value: string)
    {
        super("startswith", new ToLowerFunction(field), [value]);
    }
}
